import { Component, computed, inject, input, Input, InputSignal, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import { ApplicationPayment } from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import {
  occupationsToFormValue,
  RoadOccupationFormValue
} from '../../common/occupation-data-section/forms/road-occupation.form';
import { Store } from '@ngrx/store';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  OccupationPreviewComponent
} from '../../common/occupation-data-section/components/occupation-preview/occupation-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';

@Component({
  selector: 'app-occ-the-lane-of-excl-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    OccupationPreviewComponent,
    PaymentsDataPreviewComponent
  ],
  templateUrl: './occ-the-lane-of-excl-preview.component.html'
})
export class OccTheLaneOfExclPreviewComponent {

  private store$: Store = inject(Store);

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public roadOccupation: Signal<RoadOccupationFormValue | null> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []).at(0) || null);
}
